function Toggle(props) {
    const {name, text} = props;

    return (
        <label htmlFor={name} className="flex items-center cursor-pointer">
            <div className="relative">
                <input type="checkbox" id={name} className="sr-only"/>
                <div className="toggle-circle-background block bg-gray-600 w-10 h-6 rounded-full"/>
                <div className="toggle-circle absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"/>
            </div>
            <div className="text-gray-700 font-medium">
                {text}
            </div>
        </label>
    );
}

export default Toggle;